import { FiltroCotacoesPerdidas, TabelaCotacaoPerdida } from "app/types/CotacoesPerdidas";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import { BaseApi } from "./BaseApi";

export class CotacaoPerdidaApi extends BaseApi {

    async Listar(filtros: FiltroCotacoesPerdidas): Promise<PagedMessageResponse<TabelaCotacaoPerdida> | null> {
        const resposta = await this.api.post(`/CotacaoPerdida/Listar`, {
            filtros
        })

        return resposta.data;
    }
}
